module.exports = __webpack_public_path__ + "static/17-1df1cfb1a3ce1df491b0f91b0218b2b0.jpg";